import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "isd_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
      setToken(null);
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  },
);

export const assetUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u || "");

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || "Something went wrong";
};

export const uploadFiles = async (files) => {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append("files", f));
  const { data } = await adminApi.post("/admin/upload", fd);
  return data;
};

export const lines = (s) => (s || "").split("\n").map((x) => x.trim()).filter(Boolean);

export const fill = (tpl, vars) => (tpl || "").replace(/\{(\w+)\}/g, (m, k) => (vars[k] ?? m));
